import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { findStore } from "../../../modules/reducers/productSearch/branchList";
import { branchListApi } from "../api/branch/branchListApi";
import { productSearchApi } from "../api/product/productSearchApi";
import {
  findMoreProduct,
  findProduct,
  initProduct,
} from "../../../modules/reducers/productSearch/productSearch";
import { brandIdMap } from "../const/brandIdMap";
import { initDestination } from "../../../modules/reducers/destination/destination";
import useReactGASend from "../../../hooks/useReactGASend";

const useSearchHook = () => {
  const brandId = useSelector((state) => state.checkArsStatus.brandId);
  const list = useSelector((state) => state.branchList.storeList);
  const infinity = useSelector((state) => state.productSearch.infinity);

  const areaCodeARS = useSelector((state) => state.checkArsStatus.areaCode);
  const branchIdARS = useSelector((state) => state.checkArsStatus.branchId);
  const initKeyword = useSelector((state) => state.productSearch.keyword);
  const initAreaCode = useSelector((state) => state.productSearch.areaCode);
  const initStoreId = useSelector((state) => state.productSearch.storeId);

  const selectedArea = useSelector((state) => state.getBranches.area);
  const selectedBranchId = useSelector(
    (state) => state.getBranches.selectedBranchId
  );

  const from = useSelector((state) => state.destination.from);
  const [areaCode, setAreaCode] = useState(null); //ars를 통한 자동연결이 아닐 때 도시 코드
  const [storeId, setStoreId] = useState();
  const [branchList, setBranchList] = useState([]);
  const [brandCd, setBrandCd] = useState();
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState("");
  const [sortType, setSortType] = useState("recommend");
  const [isSelect, setIsSelect] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const { makeEventTrackFn } = useReactGASend();

  const dispatch = useDispatch();
  useEffect(() => {
    setIsMounted(true);
    if (!from?.startsWith("/search")) {
      dispatch(initProduct());
    }
  }, []);

  useEffect(() => {
    if (initKeyword && storeId && brandCd) {
      if (from?.startsWith("/search")) {
        //상품 상세에서 뒤로가기로 왔을 때
        setAreaCode(initAreaCode);
        setKeyword(initKeyword);
        dispatch(initDestination());
      }
    }
  }, [initKeyword, storeId, brandCd]);

  useEffect(() => {
    if (initAreaCode) {
      setAreaCode(initAreaCode); //선택한 점포 (뒤로가기)
    } else if (selectedArea) {
      setAreaCode(selectedArea); //인입 area 선택
    } else if (areaCodeARS) {
      setAreaCode(areaCodeARS); //인입 area 선택
    } else {
      setAreaCode("A"); //데이터 없으면 area를 기본으로 A 세팅
    }
  }, [areaCodeARS, initAreaCode]);

  useEffect(() => {
    //area 선택 된 후 branch list응답이 오면 branch 선택
    setBrandCd(brandIdMap[brandId]?.cd || null);
  }, [brandId]);

  useEffect(() => {
    setBranchList(list);
  }, [list]);

  useEffect(() => {
    if (isSelect && branchIdARS && list?.length > 0) {
      // 인입 이후 점포 list 변경시
      setStoreId(list[0].id);
    } else if (!isSelect && selectedBranchId && list?.length > 0) {
      // 인입에 점포Id(점포를 지도로 선택해야 하는 노브랜드) 있고 list 로드시 동작
      setStoreId(selectedBranchId);
    } else if (!isSelect && branchIdARS && list?.length > 0) {
      // 인입에 점포Id(ARS에서 점포 정보주는 이마트, 트레이더스 ) 있고 list 로드시 동작
      setStoreId(branchIdARS);
    } else if (!branchIdARS && list?.length > 0) {
      // branchId가 없고 점포 list가 있는 경우
      setStoreId(list[0].id);
    } else if (initStoreId) {
      setStoreId(initStoreId);
    } 
  }, [branchList]);

  useEffect(() => {
    // 키워드 순위순, 점포명, 지역명 바뀌면 자동으로 검색 해주기
    if (areaCode && brandId) {
      const api = branchListApi(areaCode, brandId);
      dispatch(findStore(api));
    }
  }, [areaCode, brandId]);

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      // 키워드 순위순, 점포명, 지역명 바뀌면 자동으로 검색 해주기
      search();
    }, 500);
    return () => clearTimeout(debounceTimer);
  }, [keyword, sortType, storeId]);

  const handleInputChange = (event) => {
    setKeyword(event.target.value);
  };

  const handleClearClick = () => {
    setKeyword("");
  };

  const selectArea = (area) => {
    setAreaCode(area);
    setIsSelect(true);
    setKeyword("");
  };

  const selectBranch = (branch) => {
    setStoreId(branch);
    setIsSelect(true);
    search(branch);
  };

  const search = (strId) => {
    const koreanRegex = /[가-힣]+/;
    if (storeId && brandCd && keyword && koreanRegex.test(keyword)) {
      setOffset(0);
      const api = productSearchApi({
        offset: 0,
        limit,
        storeId : strId || storeId,
        brandCd,
        keyword,
        sortType,
      });
      dispatch(
        findProduct({ ...api, brandId: brandCd, storeId, keyword, areaCode })
      );
    }
  };
  const fetchMoreData = () => {
    const api = productSearchApi({
      offset: offset + limit,
      limit,
      storeId,
      brandCd,
      keyword,
      sortType,
    });
    setOffset(offset + limit);
    dispatch(findMoreProduct({ ...api, offset, keyword, storeId, areaCode }));
  };

  return {
    areaCode,
    setAreaCode,
    selectArea,
    storeId,
    setStoreId,
    branchList,
    keyword,
    initKeyword,
    handleInputChange,
    handleClearClick,
    selectBranch,
    search,
    sortType,
    setSortType,
    fetchMoreData,
    infinity,
    brandCd,
    isMounted,
  };
};

export default useSearchHook;
